import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CircularProgress
} from '@mui/material';
import { GET_LOG_WIFI_POINT_API_URL } from '../../Optics/OpticApiConfig';


const LogWifi = ({ open, onClose, user }) => {

  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;

    const loadLogs = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${GET_LOG_WIFI_POINT_API_URL}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });

        const data = await response.json();
        setLogs(data);
      } catch (err) {
        console.error('Ошибка загрузки логов WiFi', err);
      } finally {
        setLoading(false);
      }
    };

    loadLogs();
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth className="modalStyle">
      <DialogContent>
        <label style={{fontSize: '18px', color: '#ffb700', textShadow: '2px 2px 4px #080808ff'}}>Логи</label>
        {loading && (
          <div style={{ textAlign: 'center', padding: 20 }}>
            <CircularProgress />
          </div>
        )}

        {!loading && (
            <div className="tableLogWifi" >
          
            <table >
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Тип</th>
                  <th>IP</th>
                  <th>MAC</th>
                  <th>Статус</th>
                  <th>Пользователь</th>
                  <th>Дата</th>
                </tr>
              </thead>
              <tbody >
                {logs.map(log => (
                  <tr key={log.wifiLocationId}>
                    <td>{log.wifiLocationId}</td>
                    <td>{log.type}</td>
                    <td>{log.ip}</td>
                    <td>{log.mac}</td>
                    <td style={{
                      color:
                        log.wifiMonitoringStatusId === 5
                          ? "#99e586"
                          : log.wifiMonitoringStatusId === 6
                          ? "#ef7777"
                          : log.wifiMonitoringStatusId === 7
                          ? "#e5ca86"
                          : "inherit",
                     
                    }}>
                      {log.status}
                    </td>
                    <td>{log.authorId}</td>
                    <td>{log.date}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          
        </div>
          // <Table size="small">
          //   <TableHead>
          //     <TableRow>
          //       <TableCell><b>Дата</b></TableCell>
          //       <TableCell><b>Статус</b></TableCell>
          //       <TableCell><b>IP</b></TableCell>
          //       <TableCell><b>MAC</b></TableCell>
          //       <TableCell><b>Автор</b></TableCell>
          //     </TableRow>
          //   </TableHead>

          //   <TableBody>
          //     {logs.map((log, index) => (
          //       <TableRow key={index}>
          //         <TableCell>{log.date}</TableCell>
          //         <TableCell>{log.status}</TableCell>
          //         <TableCell>{log.ip}</TableCell>
          //         <TableCell>{log.mac}</TableCell>
          //         <TableCell>{log.authorId}</TableCell>
          //       </TableRow>
          //     ))}
          //   </TableBody>
          // </Table>
        )}

      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} class="buttonIsCloseWifi" style={{width: '150px'}}>
          Закрыть
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogWifi;

